<div class="wrapper">
  <app-aside></app-aside>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

